
























import { defineComponent, ref } from "@vue/composition-api";
import { MessageLinkSubject } from "@scrile/api-provider/dist/api/MessageLinksProvider";
import TipController from "@/components/TipController";
import TippingView from "./components/TippingView.vue";

export default defineComponent({
  name: "Tipping",
  components: { TipController, TippingView },
  props: {
    show: { type: Boolean },
    linkSubject: { type: Object as () => MessageLinkSubject },
    threadId: { type: String },
  },
  setup(_, { emit }) {
    const success = ref(false);

    const close = () => {
      emit("close");
      success.value = false;
    };

    const setSuccess = () => {
      success.value = true;
      setTimeout(close, 2000);
    };
    return {
      success,
      setSuccess,
      close,
    };
  },
});
